import React, { ComponentType, FunctionComponent } from 'react'
import { DriversLicence, Medicare, Passport } from '../'
import { IdentityDocument, DocumentProps } from '../../model'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'

interface Props extends DocumentProps {
  documentType: IdentityDocument
}

const Components: Record<IdentityDocument, ComponentType<DocumentProps>> = {
  licence: DriversLicence,
  passport: Passport,
  medicare: Medicare,
}

export const VerifyDocument: FunctionComponent<Props> = ({ documentType, onSuccess, onFailure }) => {
  const Comp = Components[documentType]
  return (
    <MaskedElement actionName={`Select ${documentType?.toString() ?? 'Unknown Document'} Input`}>
      <Comp onSuccess={onSuccess} onFailure={onFailure} />
    </MaskedElement>
  )
}
